export default __webpack_public_path__ + "static/media/pinmap.3f906df5.svg";